import React from 'react';
import cls from 'classnames';
import { Button } from '../button';
import styles from './popover.module.scss';
import FontAwesomeIcon from '../fa_icon';

export type PopoverHeaderProps = {
  title?: React.ReactNode;
  action?: {
    onClick: (e: React.MouseEvent) => void;
  };
}

/**
 * Header part of a popover.
 * @author Johan Svensson
 */
export default function PopoverHeader(props: PopoverHeaderProps) {
  const children = (
    <>
      {
        props.title ? (
          <h3 className={styles.title}>{props.title}</h3>
        ) : null
      }
      {
        props.action ? (
          <Button
            className={styles.action}
            onClick={props.action.onClick}>
            <FontAwesomeIcon name="times" />
          </Button>
        ) : null
      }
    </>
  );

  return (
    <div className={styles.header}>
      {children}
    </div>
  )
}